/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Column_Created2Inputs */

const en_settings_reportingapikeys_column_created2 = /** @type {(inputs: Settings_Reportingapikeys_Column_Created2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Settings_Reportingapikeys_Column_Created2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_column_created2 = /** @type {((inputs?: Settings_Reportingapikeys_Column_Created2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Column_Created2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_column_created2(inputs)
});
export { settings_reportingapikeys_column_created2 as "settings_reportingApiKeys_column_created" }